import { render } from "./opener.vue?vue&type=template&id=8dfb2ebe&scoped=true"
import script from "./opener.vue?vue&type=script&lang=js"
export * from "./opener.vue?vue&type=script&lang=js"

import "./opener.vue?vue&type=style&index=0&id=8dfb2ebe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dfb2ebe"]])

export default __exports__